import React from 'react'
import { Link } from 'react-router-dom'
import './assets/scss/styles.scss'

export default function NotFoundMessage(props) {
    return (
        <div className={props.className ? props.className : null}>
            <span>
                {!props.hideButton ?
                <Link to={props.url ? props.url : "#"} className={props.btnClassName ? props.btnClassName : null}>
                    {props.btnText ? props.btnText : null}
                </Link>
                : null}
            </span>
        </div>
    )
}
